module.exports = Promise.all([
    import("utils/security"),
    import("utils/config"),
    import("jquery.actual"),
    import("angular"),
    import("angular-symfony-translation/angular-symfony-translation"),
    import("tap-directives/tap-directives"),
    import("tap-services/storage-factory"),
]).then(deps => {
    let [Security, config] = deps;

    var app = angular
        .module("tapSplitView", ["boxuk.translation", "tapDirectives", "tapServices"])
        .constant("templateFolder", "/bundles/tapsite/html/split-view/");

    require("tap-split-view/view-stack");

    app.factory("gcd", function($rootScope) {
        var sharedService = {};

        sharedService.message = "";

        sharedService.broadcast = function(msg, type) {
            this.message = msg;
            if (type == "master") {
                this.masterBroadcast();
            }
        };

        sharedService.masterBroadcast = function() {
            $rootScope.$broadcast("handleMasterBroadcast");
        };

        return sharedService;
    });

    app.factory("dataStorage", [
        "storageFactory",
        function(storageFactory) {
            return storageFactory.getInstance("splitView");
        },
    ]);

    app.directive("splitView", [
        "dataStorage",
        "viewStack",
        "$rootScope",
        "templateFolder",
        function(dataStorage, viewStack, $rootScope, templateFolder) {
            var self = {};

            var onCompile = function(element, attributes) {
                if (attributes.storageUrl) {
                    self.storageUrl = attributes.storageUrl;
                }

                self.masterTemplateUrl = attributes.masterTemplateUrl;
                self.detailTemplateUrl = attributes.detailTemplateUrl;
                self.noDetailTopbar = attributes.noDetailTopbar || false;
                self.masterTitle = attributes.title || "";
            };

            return {
                restrict: "E",
                compile: onCompile,
                templateUrl: templateFolder + "split-view.html?v3",
                controller: function($scope) {
                    $scope.splitViewVars = {};
                    $scope.splitViewVars.noView = false;
                    $scope.splitViewVars.selectedItem = null;
                    $scope.splitViewVars.noDetailTopbar = self.noDetailTopbar;
                    $scope.splitViewVars.showTopBar = false;

                    if (self.storageUrl)
                        dataStorage.init(self.storageUrl, function(items) {
                            $rootScope.$broadcast("masterItemsLoaded", items);
                        });

                    if ($scope.masterItems) dataStorage.setData($scope.masterItems);

                    $scope.$on("masterItemSelected", function(event, item) {
                        if (item && item.detailTemplateUrl) {
                            $scope.detailTemplateUrl = item.detailTemplateUrl;
                            setTimeout(viewStack.positionPages, 100);
                        }
                    });

                    $scope.masterTemplateUrl = self.masterTemplateUrl;
                    $scope.detailTemplateUrl = self.detailTemplateUrl;
                    $scope.masterTitle = self.masterTitle;
                    $scope.Security = Security;

                    $scope.getViewIndex = function() {
                        return viewStack.getViewIndex();
                    };

                    $scope.isMobile = function() {
                        return $(window).outerWidth() < 768;
                    };

                    $scope.backOneView = function() {
                        return viewStack.popView();
                    };

                    $scope.addDataStoreItem = function(item) {
                        dataStorage.addItem(item);
                    };

                    $scope.itemSelected = function(item) {
                        if (item.itemDisabled) return;

                        $rootScope.$broadcast("masterItemSelected", item);
                        $scope.splitViewVars.selectedItem = item;
                        viewStack.reset();
                        viewStack.pushView(null, { animated: false });
                    };

                    $scope.isSelectedItem = function(item) {
                        return $scope.splitViewVars.selectedItem === item;
                    };

                    $scope.isEmptyObject = function(obj) {
                        return Object.keys(obj).length === 0 && obj.constructor === Object;
                    };

                    $scope.$on("viewstackPosition", function() {
                        viewStack.positionPages();
                    });

                    $scope.$on("newDataStoreItem", function(ev, item) {
                        dataStorage.addItem(item);
                    });

                    $scope.$on("removeDataStoreItem", function(ev, item) {
                        dataStorage.removeItem(item);
                    });
                },
                controllerAs: "splitViewCtrl",
            };
        },
    ]);

    app.directive("infiniteScroll", function() {
        return function(scope, elm, attr) {
            var raw = elm[0];

            elm.bind("scroll", function() {
                if (raw.scrollTop + raw.offsetHeight >= raw.scrollHeight) {
                    scope.$apply(attr.infiniteScroll);
                }
            });
        };
    });

    app.controller("masterCtrl", [
        "$scope",
        "$rootScope",
        "$filter",
        "dataStorage",
        "gcd",
        "viewStack",
        "$parse",
        "$timeout",
        function($scope, $rootScope, $filter, dataStorage, gcd, viewStack, $parse, $timeout) {
            "use strict";

            var items = [];
            $scope.content = items;
            $scope.masterIsRefreshing = true;
            $scope.masterFilters = $scope.filterDefs || [];
            $scope.selectedMasterFilter = $scope.masterFilters[0];
            $scope.masterFiltersTwo = $scope.filterDefsTwo || [];
            $scope.selectedMasterFilterTwo = $scope.masterFiltersTwo[0];
            $scope.masterSortOptions = $scope.sortOptions || [];
            $scope.selectedMasterSorting = $scope.masterSortOptions[0];
            $scope.fetchingMore = false;
            $scope.titleView = $scope.titleView || {};

            $scope.$on("invokeMasterItemSelected", function(ev, item) {
                $scope.itemSelected(item);
            });

            $scope.$on("resetViewStack", function(ev, item) {
                $scope.splitViewVars.selectedItem = item;
                $rootScope.$broadcast("masterItemSelected", item);
                viewStack.reset();
            });

            $scope.setMasterFilter = function(filter) {
                $scope.selectedMasterFilter = filter;

                if (filter.type === "objectProperty") {
                    var _items = $filter("filter")(items, filter.expression, false);
                    $scope.content = $filter("tapGroup")(_items);
                } else if (filter.type === "queryParam") {
                    $scope.masterIsRefreshing = true;
                    $scope.content = [];

                    var filterParams = filter.params;
                    if ($scope.selectedMasterFilterTwo.params) {
                        filterParams += "&" + $scope.selectedMasterFilterTwo.params;
                    }

                    dataStorage.setFilter(filterParams);
                    dataStorage.refresh(function(items) {
                        $scope.masterIsRefreshing = false;
                        $scope.content = $filter("tapGroup")(items);
                    });
                }
            };

            $scope.setMasterFilterTwo = function(filter) {
                $scope.selectedMasterFilterTwo = filter;

                if (filter.type === "objectProperty") {
                    var _items = $filter("filter")(items, filter.expression, false);
                    $scope.content = $filter("tapGroup")(_items);
                } else if (filter.type === "queryParam") {
                    $scope.masterIsRefreshing = true;
                    $scope.content = [];

                    var filterParams = filter.params;
                    if ($scope.selectedMasterFilter.params) {
                        filterParams += "&" + $scope.selectedMasterFilter.params;
                    }

                    dataStorage.setFilter(filterParams);
                    dataStorage.refresh(function(items) {
                        $scope.masterIsRefreshing = false;
                        $scope.content = $filter("tapGroup")(items);
                    });
                }
            };

            $scope.setMasterSorting = function(sorting) {
                $scope.selectedMasterSorting = sorting;

                if (sorting.type === "queryParam") {
                    $scope.masterIsRefreshing = true;
                    $scope.content = [];
                    dataStorage.setSorting(sorting.params);
                    dataStorage.refresh(function(items) {
                        $scope.masterIsRefreshing = false;
                        $scope.content = $filter("tapGroup")(items);
                    });
                }
            };

            $scope.loadMore = function() {
                if ($scope.masterIsRefreshing || !dataStorage.hasNext()) return;
                $scope.fetchingMore = true;
                var el = $(".mv-cells-holder");
                var scrollPos = el[0].scrollTop;
                dataStorage.refresh(function() {
                    $scope.fetchingMore = false;
                    $timeout(function() {
                        el[0].scrollTop = scrollPos;
                    }, 10);
                }, "next");
            };

            $scope.hasNext = function() {
                return dataStorage.hasNext();
            };

            var typeTimer = null;

            $scope.$watch("search", function(newValue) {
                if (newValue === undefined) return;

                $scope.content = [];
                $scope.masterIsRefreshing = true;

                if (typeTimer) $timeout.cancel(typeTimer);
                typeTimer = $timeout(function() {
                    dataStorage.setQuery(newValue);
                    dataStorage.refresh(function(_items) {
                        $scope.masterIsRefreshing = false;
                        $scope.content = $filter("tapGroup")(_items);
                    });
                }, 500);
            });

            $scope.$watch(
                function() {
                    return dataStorage.get();
                },
                function(newValue) {
                    if (!newValue) return ($scope.content = []);

                    $scope.$emit("splitViewDataLoaded", $scope);

                    $scope.masterIsRefreshing = false;

                    if (items.length !== newValue.length) {
                        items = angular.copy(newValue);
                        $scope.content = $filter("tapGroup")(items);
                    }
                },
                true,
            );
        },
    ]);

    app.controller("detailCtrl", [
        "$scope",
        "viewStack",
        function($scope, viewStack) {
            "use strict";

            $scope.item = null;
            $scope.topBar = {};
            $scope.bottomBar = {};

            $scope.util = {
                keys: obj => {
                    if (typeof obj === "undefined") return [];

                    return Object.keys(obj);
                },
                push: Array.push,
                typeof: function(arg) {
                    return typeof arg;
                },
                removeItem: function(array, item) {
                    array.splice(item, 1);
                },
                isDefined: function(val) {
                    return typeof val !== "undefined";
                },
            };

            $scope.broadcast = function(message, item) {
                $scope.$broadcast(message, item);
            };

            $scope.$on("masterItemSelected", function(messag, item) {
                $scope.item = item;
            });

            $scope.init = function(selector) {
                if (viewStack.isEmpty()) {
                    viewStack.addToStack(selector);
                }

                viewStack.prepare(selector);
            };

            $scope.pushView = function(selector, scopeItems) {
                // Set new detail view's item
                var el = document.querySelector(selector);
                var controllerScope = angular.element(el).scope();

                for (var item in scopeItems) {
                    if (scopeItems.hasOwnProperty(item)) {
                        controllerScope[item] = scopeItems[item];
                    }
                }

                viewStack.pushView(selector);
            };

            $scope.popView = function() {
                viewStack.popView();
            };

            $scope.getCurrentViewTitle = function() {
                return viewStack.getCurrentViewTitle();
            };

            $scope.hasView = function() {
                return viewStack.getViewIndex() >= 0;
            };

            // Quick hack
            // TODO: Find more elegant solution
            // TODO: Use debounced version
            angular.element(".dv-page-holder").on("scroll", function() {
                $(".overlay").css("top", $(this).scrollTop());
            });
        },
    ]);

    app.controller("rightViewCtrl", [
        "$scope",
        "$rootScope",
        "viewStack",
        function($scope, $rootScope, viewStack) {
            "use strict";

            $scope.rightViewContent = null;
            $scope.rightViewTitle = null;

            $scope.$on("rightViewDataUpdated", function(ev, data) {
                $scope.rightViewTitle = data.title;
                $scope.rightViewContent = data.content;
            });

            $rootScope.rightViewVisible = function() {
                return viewStack.getViewIndex() >= 0 && $scope.rightViewContent;
            };
        },
    ]);

    app.filter("tapGroup", function() {
        return function(objects) {
            var result = {
                _other: [],
            };

            var order = [];

            objects = objects || [];

            for (var i = objects.length - 1; i >= 0; i--) {
                var object = objects[i];

                if (!object.group) {
                    result._other.push(object);
                }

                if (!result[object.group]) {
                    result[object.group] = [];
                    order.push(object.group);
                }

                result[object.group].push(object);
            }

            var orderedResult = [];

            for (var i = order.length - 1; i >= 0; i--) {
                if (!orderedResult[i]) {
                    orderedResult[i] = {
                        title: order[i],
                    };
                }
                orderedResult[i].values = result[order[i]].reverse();
            }

            orderedResult.reverse();

            return orderedResult;
        };
    });

    app.directive("tapTooltip", function() {
        return {
            restrict: "A",
            link: function(scope, elm, attr) {
                var options = { animation: false };
                if (attr.tapTooltip) options.title = attr.tapTooltip;
                elm.tooltip(options);
            },
        };
    });

    app.directive("tapPopover", function() {
        require("bootstrap/js/tooltip");
        require("bootstrap/js/popover");
        return {
            restrict: "A",
            link: function(scope, elm, attr) {
                var options = { trigger: "hover" };

                if (attr.title) options.title = attr.title;

                if (attr.tapPopover) {
                    options.title = attr.tapTooltip;
                    options.message = attr.dataContent;
                }

                elm.popover(options);
            },
        };
    });

    app.directive("compile", [
        "$compile",
        function($compile) {
            return function(scope, element, attrs) {
                scope.$watch(
                    function(scope) {
                        return scope.$eval(attrs.compile);
                    },
                    function(value) {
                        element.html(value);
                        $compile(element.contents())(scope);
                    },
                );
            };
        },
    ]);
});
